import React from 'react';
import cn from 'classnames';
import { fieldNames } from '../../config/form';
import FormItem from '../FormItem/FormItem';
import Group from './Group';
import { requiredRule } from '../../model/form';
import PaymentTypesFetcher from '../PaymentTypesFetcher/PaymentTypesFetcher';
import styles from './index.module.scss';

const Base = ({ types, getFieldDecorator, initVal, showLabel = true }) => {
  return (
    <FormItem
      label={showLabel ? 'Способы оплаты' : undefined}
      className={cn(styles.formItem)}
    >
      {getFieldDecorator(fieldNames.paymentTypes, {
        initialValue: initVal || [],
        rules: [requiredRule({ msg: 'Выберите способ оплаты', type: 'array' })],
      })(<Group items={types} />)}
    </FormItem>
  );
};

const PaymentTypesField = ({ id, getFieldDecorator, initVal, showLabel }) => {
  return (
    <PaymentTypesFetcher requestId={id}>
      {({ types }) => (
        <Base
          types={types}
          getFieldDecorator={getFieldDecorator}
          initVal={initVal}
          showLabel={showLabel}
        />
      )}
    </PaymentTypesFetcher>
  );
};

export default PaymentTypesField;
